import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  addCompetitionAthletesStart:
    '[add competition Athletes] Create competition Athletes start',
  addCompetitionAthletesSuccess:
    '[add competition Athletes] Create competition Athletes success',
  addCompetitionAthletesFailure:
    '[add competition Athletes] Create competition Athletes failure',
}

export const actionTypes = {
  addCompetitionAthletes:
    '[add competition Athletes] Create competition Athletes',
}

const mutations = {
  [mutationTypes.addCompetitionAthletesStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.addCompetitionAthletesSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addCompetitionAthletesFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.addCompetitionAthletes](context, {athlete, id}) {
    context.commit(mutationTypes.addCompetitionAthletesStart)
    return new Promise((resolve) => {
      apiCompetitions
        .addCompetitionAthletes(athlete, id)
        .then((response) => {
          context.commit(mutationTypes.addCompetitionAthletesSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.addCompetitionAthletesFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
